// extracted by mini-css-extract-plugin
module.exports = {"Emojify":"vu_a bag_g"};